import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "ID", key: "id" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "IP Address", key: "ipAddress" },
    { label: "User ID", key: "userId" },
    { label: "User Name", key: "userName" },
    { label: "Action", key: "action" },
    { label: "Created Date", key: "createdDate" },
  ];

  return (
    <div className="main-form form-details">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key, value }) => (
          <div key={label} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{value ?? rowData?.[key] ?? "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
